module.exports = __webpack_public_path__ + "img/icon-write.f2d7de73.svg";